<template>
  <page class="home">

  </page>
</template>

<script>
export default {
  name: "Home",
  mounted() {
    this.$router.push({
      name: 'records-grid'
    })
  }
}
</script>

<style lang="scss" scoped>
.home {
  height: 1920px;
}
</style>